"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireDefault(require("../../../utils/system"));

var _ListItemText = _interopRequireDefault(require("../ListItemText/ListItemText"));

var _ListItemIcon = _interopRequireDefault(require("../ListItemIcon/ListItemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /**
   * Add a background for selected items.
   */
  selected: _propTypes.bool,

  /**
   * Add a bottom separator and increase the padding top.
   */
  separator: _propTypes.bool
};
var defaultProps = {
  selected: false,
  separator: false
};
var ListItem = (0, _system["default"])('div')({
  label: 'ListItem'
}, (0, _css["default"])({
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'flex-start',
  py: 2,
  px: 4,
  textAlign: 'left',
  textDecoration: 'none',
  width: '100%'
}), function (_ref) {
  var selected = _ref.selected;
  return selected && (0, _css["default"])({
    bg: 'blackAlpha.200'
  });
}, function (_ref2) {
  var separator = _ref2.separator,
      isLast = _ref2.isLast;
  return separator && (0, _css["default"])({
    py: 4,
    borderBottom: !isLast ? '1px' : undefined,
    borderBottomColor: !isLast ? 'gray.200' : undefined
  });
});
ListItem.displayName = 'ListItem';
ListItem.propTypes = propTypes;
ListItem.defaultProps = defaultProps;
ListItem.Text = _ListItemText["default"];
ListItem.Icon = _ListItemIcon["default"];
var _default = ListItem;
exports["default"] = _default;

//# sourceMappingURL=ListItem.js.map